import { Gender } from '../../../../corelogic/domain/models/gender.enum';
import { buildFighterKey } from '../../../../corelogic/domain/utils/fighterImage.utils';
import { retrieveFighterImage } from '../../../../corelogic/state/image/image.action';
import { getFighterImage } from '../../../../corelogic/state/image/image.selector';
import { store } from '../../../../corelogic/state/store';

export const FighterImageService = {
  retrieveFighterImage: (
    firstName: string | undefined,
    lastName: string | undefined,
    dob: Date,
    gender: Gender,
  ) => {
    // Use the new utility function to build the key
    const imagePath = buildFighterKey(firstName, lastName, dob);

    if (!imagePath) {
      console.warn(
        'FighterImageService: Missing required fighter data, skipping image request',
      );
      return;
    }

    // Check if image already exists in store before dispatching action
    const currentState = store.getState();
    const existingImage = getFighterImage(imagePath)(currentState);

    // If the image already exists, return
    if (existingImage) {
      return;
    }

    // If the image does not exist, dispatch the action to retrieve it
    store.dispatch(
      retrieveFighterImage({ firstName, lastName, dob, gender, retry: 0 }),
    );
  },
};
